export default __webpack_public_path__ + "static/media/logo.282f3c3a.png";